module.exports = __webpack_public_path__ + "images/img-35158Fj.jpg";


//////////////////
// WEBPACK FOOTER
// ./frontend/cabinets/apps/rocket/assets/img/dashboard/year-results/ru/managers/80.jpg
// module id = 2023
// module chunks = 0